import { render, staticRenderFns } from "./newcontributeGf.vue?vue&type=template&id=2d7448a0&scoped=true"
import script from "./newcontributeGf.vue?vue&type=script&lang=js"
export * from "./newcontributeGf.vue?vue&type=script&lang=js"
import style0 from "./newcontributeGf.vue?vue&type=style&index=0&id=2d7448a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7448a0",
  null
  
)

export default component.exports